import * as React from "react";
import { ProductCard } from "../../NormalProducts/ProductCard";
import { TomatoCardItem } from "../../NormalProducts/NewProductCards/TomatoCard";
import { DoubleContainer, GridRowTwoBox } from "./styles";
import { TomatoLeftArrow, TomatoRightArrow } from "../styles";
import { ModuleLayoutStyle } from "../../../../services/playground";
const _animationDuration = 1000;
class DoubleSwipe extends React.Component {
    constructor() {
        super(...arguments);
        this.canClick = true;
        this.autoSwipe = true;
        this.countDown = 0;
        this.gridCellLen = this.props.gridCol * 2;
        this.state = {
            cIndex: 0,
            animationDuration: 0,
            aniIndex: 1,
        };
        this.onBack = () => {
            const { cIndex } = this.state;
            const { products } = this.props;
            if (!this.canClick) {
                return;
            }
            this.canClick = false;
            this.setState({
                aniIndex: 0,
                animationDuration: _animationDuration,
            });
            setTimeout(() => {
                const newCIndex = cIndex - this.gridCellLen;
                this.setState({
                    cIndex: newCIndex < 0 ? products.length + newCIndex : newCIndex,
                    animationDuration: 0,
                    aniIndex: 1,
                });
                this.canClick = true;
            }, _animationDuration);
        };
        this.onNext = () => {
            const { cIndex } = this.state;
            const { products } = this.props;
            if (!this.canClick || products.length <= this.gridCellLen) {
                return;
            }
            this.canClick = false;
            this.setState({
                aniIndex: 2,
                animationDuration: _animationDuration,
            });
            setTimeout(() => {
                const newCIndex = cIndex + this.gridCellLen;
                this.setState({
                    cIndex: newCIndex >= products.length ? newCIndex - products.length : newCIndex,
                    animationDuration: 0,
                    aniIndex: 1,
                });
                this.canClick = true;
            }, _animationDuration);
        };
        this.getDoubleStyle = () => {
            const { aniIndex, animationDuration } = this.state;
            const style = {};
            const { gridWidth = 1200 } = this.props;
            style.width = "300%";
            const wrapperOffsetLeft = -gridWidth * aniIndex;
            style.transform = `translate3d(${wrapperOffsetLeft}px,0,0)`;
            style.transitionDuration = `${animationDuration}ms`;
            style.WebkitTransform = style.transform;
            style.transitionTimingFunction = "ease-out";
            return style;
        };
        this.renderCard = (product, index) => {
            const { cardWidth, posterRatio, layoutStyle, placeholderBg, onClick } = this.props;
            if (layoutStyle === ModuleLayoutStyle.Tomato) {
                return (React.createElement(TomatoCardItem, { key: index, product: product, imgWidth: +cardWidth, posterRatio: posterRatio, placeholderBg: placeholderBg }));
            }
            return (React.createElement(ProductCard, { key: index, product: product, width: `${cardWidth}px`, posterRatio: posterRatio, gridCol: this.props.gridCol, layoutStyle: layoutStyle, onClick: () => onClick && onClick((index + 1).toString(), product.gpid), placeholderBg: placeholderBg }));
        };
        this.renderLeft = () => {
            const { products } = this.props;
            const { cIndex } = this.state;
            if (!cIndex) {
                return products
                    .slice(-this.gridCellLen)
                    .map((product, index) => this.renderCard(product, index));
            }
            if (cIndex - this.gridCellLen < 0) {
                return products
                    .slice(-(this.gridCellLen - cIndex))
                    .concat(products.slice(0, cIndex))
                    .map((product, index) => this.renderCard(product, index));
            }
            return products
                .slice(cIndex - this.gridCellLen, cIndex)
                .map((product, index) => this.renderCard(product, index));
        };
        this.renderMiddle = () => {
            const { products } = this.props;
            const { cIndex } = this.state;
            if (cIndex + this.gridCellLen > products.length) {
                return products
                    .slice(cIndex)
                    .concat(products.slice(0, cIndex + this.gridCellLen - products.length))
                    .map((product, index) => this.renderCard(product, index));
            }
            return products
                .slice(cIndex, cIndex + this.gridCellLen)
                .map((product, index) => this.renderCard(product, index));
        };
        this.renderRight = () => {
            const { products } = this.props;
            const { cIndex } = this.state;
            const nextCIndex = cIndex + this.gridCellLen * 2;
            if (nextCIndex <= products.length) {
                return products
                    .slice(cIndex + this.gridCellLen, cIndex + this.gridCellLen * 2)
                    .map((product, index) => this.renderCard(product, index));
            }
            if (nextCIndex > products.length && cIndex + this.gridCellLen < products.length) {
                return products
                    .slice(cIndex + this.gridCellLen)
                    .concat(products.slice(0, this.gridCellLen - (products.length - (cIndex + this.gridCellLen))))
                    .map((product, index) => this.renderCard(product, index));
            }
            if (cIndex + this.gridCellLen > products.length && nextCIndex > products.length * 2) {
                return products
                    .slice(this.gridCellLen - (products.length - cIndex))
                    .concat(products.slice(0, this.gridCellLen -
                    products.slice(this.gridCellLen - (products.length - cIndex)).length))
                    .map((product, index) => this.renderCard(product, index));
            }
            return products
                .slice(this.gridCellLen - (products.length - cIndex), this.gridCellLen * 2 - (products.length - cIndex))
                .map((product, index) => this.renderCard(product, index));
        };
    }
    render() {
        const { posterHeight, gridCol, gridGap, cardWidth, gridWidth, layoutStyle } = this.props;
        const isTomato = layoutStyle === ModuleLayoutStyle.Tomato;
        return (React.createElement(DoubleContainer, { isTomato: isTomato, onMouseEnter: () => (this.autoSwipe = false), onMouseLeave: () => (this.autoSwipe = true) },
            isTomato ? (React.createElement(TomatoLeftArrow, { onClick: this.onBack })) : (React.createElement("div", { className: "leftArrow", onClick: this.onBack })),
            React.createElement("section", { className: "scrollContainer", style: this.getDoubleStyle() },
                React.createElement("div", { className: "box" },
                    React.createElement(GridRowTwoBox, { posterHeight: posterHeight, gridCol: gridCol, cardWidth: cardWidth, gridGap: gridGap, gridWidth: gridWidth }, this.renderLeft())),
                React.createElement("div", { className: "box" },
                    React.createElement(GridRowTwoBox, { posterHeight: posterHeight, gridCol: gridCol, cardWidth: cardWidth, gridGap: gridGap, gridWidth: gridWidth }, this.renderMiddle())),
                React.createElement("div", { className: "box" },
                    React.createElement(GridRowTwoBox, { posterHeight: posterHeight, gridCol: gridCol, cardWidth: cardWidth, gridGap: gridGap, gridWidth: gridWidth }, this.renderRight()))),
            isTomato ? (React.createElement(TomatoRightArrow, { onClick: this.onNext })) : (React.createElement("div", { className: "rightArrow", onClick: this.onNext }))));
    }
}
export default DoubleSwipe;
